import React, { useEffect, useState } from 'react';

const CustomYesNoSwitch = ({ value, onChange, options, setShowCreateAccountSuggestion, setValidity }) => {
  const [selectedOption, setSelectedOption] = useState(value); // Initialize with the default value

  useEffect(() => {
    setSelectedOption(value); // Ensure it syncs with the prop when it changes
  }, [value]);

  const handleButtonClick = (optionValue, event) => {
    event.preventDefault();
    event.stopPropagation(); // Prevent event bubbling

    setSelectedOption(optionValue); // Update the selected option
    onChange(optionValue);

    if (optionValue === 'non') {
      setShowCreateAccountSuggestion?.(true);
    }
    setValidity?.("versionUsed", true);
  };

  //Defines a specific color for a specific value
  const getButtonClass = (optionValue) => {
    if (optionValue === selectedOption) {
      return optionValue === "V2" ? "bg-blue-600 text-white" : "bg-yellow-700 text-blue-900";
    }
    return "bg-gray-100";
  };

  return (
    <div className="p-1 rounded-full">
      <div className="flex flex-row gap-2 justify-between">
        {options.map(({ label, value: optionValue }) => (
          <button
            key={optionValue}
            className={`flex items-center justify-center px-3 py-1 text-sm rounded-full ${getButtonClass(optionValue)}`}
            onClick={(e) => handleButtonClick(optionValue, e)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomYesNoSwitch;